import { message } from 'antd';

import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects'
import { fetchModalityAPI } from '../../../services/modality-service';

import {
    FETCH_MODALITY_TYPES_START,
    FETCH_MODALITY_TYPES_SUCCESS,
    FETCH_MODALITY_TYPES_ERROR,
    FETCH_MODALITY_TYPES,
} from "../../actions/common/modality-action";

const MODALITY_TYPES_CACHE_KEY = "modalityTypesCachedAt";
const MODALITY_TYPES_CACHE_TTL = 30 * 60 * 1000;

const getCachedModalityTypes = (state) => state.modalityTypes.modalityTypes || [];

export function* fetchModalityTypes() {
    try {
        const cachedModalityTypes = yield select(getCachedModalityTypes);
        const cachedAt = Number(localStorage.getItem(MODALITY_TYPES_CACHE_KEY));
        const isCacheValid = cachedModalityTypes.length > 0
            && cachedAt
            && Date.now() - cachedAt < MODALITY_TYPES_CACHE_TTL;

        if (isCacheValid) {
            yield put({ type: FETCH_MODALITY_TYPES_SUCCESS, modalityTypes: cachedModalityTypes })
            return;
        }

        yield put({ type: FETCH_MODALITY_TYPES_START })
        const response = yield call(fetchModalityAPI);
        if (response.success) {
            yield put({ type: FETCH_MODALITY_TYPES_SUCCESS, modalityTypes: response.modalityTypes })
            localStorage.setItem("modalityTypes", JSON.stringify(response.modalityTypes));
            localStorage.setItem(MODALITY_TYPES_CACHE_KEY, Date.now().toString());
        } else {
            yield put({ type: FETCH_MODALITY_TYPES_ERROR, error: response.error })
            message.error('Failed to fetch modality types!');
        }
    } catch (error) {
        yield put({ type: FETCH_MODALITY_TYPES_ERROR, error })
        message.error('Failed to fetch modality types!');
    }
}

function* modalityTypesWatcher() {
    yield takeLatest(FETCH_MODALITY_TYPES, fetchModalityTypes)
}

export default function* rootSaga() {
    yield all([
        modalityTypesWatcher(),
    ]);
}
